import { catchError, map } from "rxjs/operators";
import { Inject, Injectable } from "@angular/core";
import { Resolve, Router } from "@angular/router";
import { Observable, of } from "rxjs";
import { DefaultActionFactory, DefaultActionFactoryToken } from "@core/redux/redux.module";
import { LocalStoreService } from "../utils/local-store.service";

@Injectable()
export class StatusResolve implements Resolve<Object> {
  protected _actionFactory: DefaultActionFactory;

  constructor(
    protected router: Router,
    @Inject(DefaultActionFactoryToken) actionFactory: DefaultActionFactory) {
    this._actionFactory = actionFactory;
  }

  public resolve(): Observable<Object> {
    return this._actionFactory.getStatus().pipe(
      map((response: Object) => {
        return response ? response : {};
      }),
      catchError( (_ => {
        LocalStoreService.clear();
        this.router.navigate(["mkb3ds", "login"]);
        return of(null);
      }))
    );
    return null;
  }
}
